// import axios from '../../src/interceptor/axios-config';
import axios from 'axios';
// import swal from "sweetalert";  
import Swal from 'sweetalert2';
import {
    loginConfirmedAction,
    Logout,
} from '../store/actions/AuthActions';

import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase/auth";


const FIREBASE_API_KEY = 'AIzaSyDGomaSPFdQ717-hWqetNU5tIwbmHshvZw';

export function signUp(email, password) {
    //axios call 
    const postData = {
        email,
        password,
        returnSecureToken: true,
    };
    return axios.post(
        `https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=${FIREBASE_API_KEY}`,
        postData,
    );
}

export function login(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
}

//Modified on 25 Feb 2025 for Formating Error
export function formatError(errorResponse) {
    if (errorResponse && errorResponse.error) {
        // Check for specific error messages
        switch (errorResponse.error.message) {
            case 'EMAIL_EXISTS':
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Email already exists",
                });
                break;
            case 'EMAIL_NOT_FOUND':
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Email not found",
                    confirmButtonText: "Try Again!", // ✅ Corrected this
                });
                break;            
            case 'INVALID_LOGIN_CREDENTIALS':
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Invalid Email or Password",
                    confirmButtonText: "Try Again!", // ✅ Corrected this
                });
                break;
            case 'USER_DISABLED':
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "User Disabled",
                });
                break;
            default:
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "An unknown error occurred.",
                });
        }

        // Handle nested error messages
        if (errorResponse.error.errors && errorResponse.error.errors.length > 0) {
            return errorResponse.error.errors[0].message;
        }

        // Fallback to the general error message
        return errorResponse.error.message || 'An unknown error occurred.';
    }

    return 'An unknown error occurred.';
}



export function saveTokenInLocalStorage(tokenDetails) {
    tokenDetails.expireDate = new Date(
        new Date().getTime() + tokenDetails.expiresIn * 1000,
    );
    localStorage.setItem('userDetails', JSON.stringify(tokenDetails));
}

export function runLogoutTimer(dispatch, timer, navigate) {
    setTimeout(() => {
        //dispatch(Logout(history));
        dispatch(Logout(navigate));
    }, timer);
}

export function checkAutoLogin(dispatch, navigate) {
    const tokenDetailsString = localStorage.getItem('userDetails');
    let tokenDetails = '';
    if (!tokenDetailsString) {
        // dispatch(Logout(navigate));
        dispatch(Logout());

		return;
    }

    tokenDetails = JSON.parse(tokenDetailsString);
    let expireDate = new Date(tokenDetails.expireDate);
    let todaysDate = new Date();

    if (todaysDate > expireDate) {
        dispatch(Logout(navigate));
        return;
    }
		
    dispatch(loginConfirmedAction(tokenDetails));
	
    const timer = expireDate.getTime() - todaysDate.getTime();
    runLogoutTimer(dispatch, timer, navigate);
}

export function isLogin() {
    const tokenDetailsString = localStorage.getItem('userDetails');

    if (tokenDetailsString) {
        return true;
    }else{
        return false;
    }
}
